import { EditOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

export type EditableInputProps = {
  value: string | undefined;
  onValueUpdated: (value: string) => void;
};

export const EditableInput = forwardRef(({ value, onValueUpdated }: EditableInputProps, ref) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
    }
    return () => {};
  }, [editing]);

  useImperativeHandle(ref, () => ({
    triggerEdit: () => {
      setEditing(true);
    },
  }));

  const updateValue = (e) => {
    const newValue: string = e.target.value;
    const trimmedNewValue = newValue.trim();
    if (!trimmedNewValue) {
      setEditing(false);
      return;
    }

    setEditing(false);
    onValueUpdated(trimmedNewValue);
  };

  return (
    <div className="h-7 max-w-[300px] transform translate-x-[-4px]">
      {editing ? (
        <div>
          <Input
            className="h-7 text-xl font-semibold box-border"
            size={'small'}
            ref={inputRef}
            defaultValue={value}
            onPressEnter={updateValue}
            onBlur={updateValue}
            input-id={value}
          />
        </div>
      ) : (
        <div className="flex gap-1 h-7">
          <div
            className="text-brand-grey-dark text-xl font-semibold box-border border-0 rounded hover:outline hover:outline-1 hover:outline-neutral-500 cursor-pointer px-2 text-ellipsis truncate overflow-hidden"
            onClick={() => setEditing(true)}
            title-id={value}
          >
            {value}
          </div>
          <EditOutlined className="cursor-pointer" onClick={() => setEditing(true)} />
        </div>
      )}
    </div>
  );
});
